import React from "react";

/**
 * TopMenu / PageTabs(헤더탭) 등에서 공통으로 사용하는 부모 카테고리 아이콘 매핑.
 *
 * 키 = 메뉴 데이터의 `icon` 필드 값
 */
export const topMenuIcons = {
    'static': (
        <svg
            className="static-icon"
            width="36"
            height="36"
            viewBox="0 0 36 36"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
        >
            <path
                d="M8.40207 6H13.1359C14.4631 6 15.538 7.11151 15.538 8.48379V13.3787C15.538 14.751 14.4631 15.8625 13.1359 15.8625H8.40207C7.07494 15.8625 6 14.751 6 13.3787V8.48379C6 7.11151 7.07494 6 8.40207 6Z"
                stroke="currentColor"
                strokeWidth="1.5"
                strokeMiterlimit="10"
            />
            <path
                d="M8.40207 20.1377H13.1359C14.4631 20.1377 15.538 21.2492 15.538 22.6215V27.5164C15.538 28.8887 14.4631 30.0002 13.1359 30.0002H8.40207C7.07494 30.0002 6 28.8887 6 27.5164V22.6215C6 21.2492 7.07494 20.1377 8.40207 20.1377Z"
                stroke="currentColor"
                strokeWidth="1.5"
                strokeMiterlimit="10"
            />
            <path
                className="static-icon-accent"
                d="M22.864 6H27.5978C28.925 6 29.9999 7.11151 29.9999 8.48379V13.3787C29.9999 14.751 28.925 15.8625 27.5978 15.8625H22.864C21.5369 15.8625 20.4619 14.751 20.4619 13.3787V8.48379C20.4619 7.11151 21.5369 6 22.864 6Z"
                stroke="currentColor"
                strokeWidth="1.5"
                strokeMiterlimit="10"
            />
            <path
                d="M22.864 20.1377H27.5978C28.925 20.1377 29.9999 21.2492 29.9999 22.6215V27.5164C29.9999 28.8887 28.925 30.0002 27.5978 30.0002H22.864C21.5369 30.0002 20.4619 28.8887 20.4619 27.5164V22.6215C20.4619 21.2492 21.5369 20.1377 22.864 20.1377Z"
                stroke="currentColor"
                strokeWidth="1.5"
                strokeMiterlimit="10"
            />
        </svg>
    ),
    'asset': (
        <svg xmlns="http://www.w3.org/2000/svg" width="28" height="28" viewBox="0 0 24 24" fill="none"
             stroke="currentColor" strokeWidth="1" strokeLinecap="round" strokeLinejoin="round">
            <path stroke="none" d="M0 0h24v24H0z" fill="none"/>
            <path d="M4 6a8 3 0 1 0 16 0a8 3 0 1 0 -16 0"/>
            <path d="M4 6v6a8 3 0 0 0 16 0v-6"/>
            <path d="M4 12v6a8 3 0 0 0 16 0v-6"/>
        </svg>
    ),
    'service': (
        <svg xmlns="http://www.w3.org/2000/svg" width="28" height="28" viewBox="0 0 24 24" fill="none"
             stroke="currentColor" strokeWidth="1" strokeLinecap="round" strokeLinejoin="round">
            <path stroke="none" d="M0 0h24v24H0z" fill="none"/>
            <path d="M4 14v-3a8 8 0 1 1 16 0v3"/>
            <path d="M18 19c0 1.657 -2.686 3 -6 3"/>
            <path d="M4 14a2 2 0 0 1 2 -2h1a2 2 0 0 1 2 2v3a2 2 0 0 1 -2 2h-1a2 2 0 0 1 -2 -2v-3"/>
            <path d="M15 14a2 2 0 0 1 2 -2h1a2 2 0 0 1 2 2v3a2 2 0 0 1 -2 2h-1a2 2 0 0 1 -2 -2v-3"/>
        </svg>
    ),
    'maintenance': (
        <svg
            className="maintenance-icon"
            width="36"
            height="36"
            viewBox="0 0 36 36"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
        >
            <path
                d="M29.3595 8.58531L27.5717 6.79297L23.3819 8.99644L22.592 12.0684L13.6719 20.9885L14.9792 22.2958L23.8993 13.3757L27.0636 12.6781L29.3595 8.58531Z"
                stroke="currentColor"
                strokeWidth="1.5"
                strokeLinecap="round"
                strokeLinejoin="round"
            />
            <path
                d="M15.889 22.683L13.6025 20.3965L6.47519 27.5238L8.76169 29.8103L15.889 22.683Z"
                stroke="currentColor"
                strokeWidth="1.5"
                strokeLinecap="round"
                strokeLinejoin="round"
            />
            <path
                d="M24.2786 21.7969L14.2082 11.7219C14.7395 10.2899 14.4623 8.41902 13.2104 7.16254C12.0233 5.97535 10.1986 5.75361 8.7296 6.24327L11.3904 8.90406L9.10378 11.1907L6.41527 8.50217C5.58839 10.2853 6.05957 11.8882 7.26986 13.0985C8.54945 14.3781 10.5312 14.5767 11.9447 14.0316L21.9689 24.0558C21.4238 25.4693 21.6224 27.4511 22.902 28.7306C24.1123 29.9409 25.7152 30.4121 27.4983 29.5852L24.7775 26.8644L27.0641 24.5778L29.7572 27.2709C30.2469 25.8019 30.0252 23.9773 28.838 22.7901C27.5815 21.5336 25.706 21.261 24.2786 21.7923V21.7969Z"
                stroke="currentColor"
                strokeWidth="1.5"
                strokeLinecap="round"
                strokeLinejoin="round"
            />
        </svg>
    ),
    'evaluation': (
        <svg xmlns="http://www.w3.org/2000/svg" width="28" height="28" viewBox="0 0 24 24" fill="none"
             stroke="currentColor" strokeWidth="1" strokeLinecap="round" strokeLinejoin="round">
            <path stroke="none" d="M0 0h24v24H0z" fill="none"/>
            <path d="M9 5h-2a2 2 0 0 0 -2 2v12a2 2 0 0 0 2 2h10a2 2 0 0 0 2 -2v-12a2 2 0 0 0 -2 -2h-2"/>
            <path d="M9 5a2 2 0 0 1 2 -2h2a2 2 0 0 1 2 2a2 2 0 0 1 -2 2h-2a2 2 0 0 1 -2 -2"/>
            <path d="M9 12h6"/>
            <path d="M9 16h6"/>
        </svg>
    ),
    'lifecycle': (
        <svg xmlns="http://www.w3.org/2000/svg" width="28" height="28" viewBox="0 0 24 24" fill="none"
             stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
            <path stroke="none" d="M0 0h24v24H0z" fill="none"/>
            <path d="M12 17l-2 2l2 2"/>
            <path d="M10 19h9a2 2 0 0 0 1.75 -2.75l-.55 -1"/>
            <path d="M8.536 11l-.732 -2.732l-2.732 .732"/>
            <path d="M7.804 8.268l-4.5 7.794a2 2 0 0 0 1.506 2.89l1.141 .024"/>
            <path d="M15.464 11l2.732 .732l.732 -2.732"/>
            <path d="M18.196 11.732l-4.5 -7.794a2 2 0 0 0 -3.256 -.14l-.591 .976"/>
        </svg>
    ),
    'precheck': (
        <svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" fill="currentColor" viewBox="0 0 16 16">
            <path fillRule="evenodd" d="M1 8a7 7 0 1 1 2.898 5.673c-.167-.121-.216-.406-.002-.62l1.8-1.8a3.5 3.5 0 0 0 4.572-.328l1.414-1.415a.5.5 0 0 0 0-.707l-.707-.707 1.559-1.563a.5.5 0 1 0-.708-.706l-1.559 1.562-1.414-1.414 1.56-1.562a.5.5 0 1 0-.707-.706l-1.56 1.56-.707-.706a.5.5 0 0 0-.707 0L5.318 5.975a3.5 3.5 0 0 0-.328 4.571l-1.8 1.8c-.58.58-.62 1.6.121 2.137A8 8 0 1 0 0 8a.5.5 0 0 0 1 0"/>
        </svg>
    ),
    'standard': (
        <svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" fill="currentColor" viewBox="0 0 16 16">
            <path d="M10.338 5.968h-.844v4.06h.844c1.116 0 1.622-.667 1.622-2.02 0-1.354-.51-2.04-1.622-2.04"/>
            <path d="M0 4a2 2 0 0 1 2-2h12a2 2 0 0 1 2 2v8a2 2 0 0 1-2 2H2a2 2 0 0 1-2-2zm5.077 7.114c1.521 0 2.378-.764 2.378-1.88 0-1.007-.642-1.473-1.613-1.692l-.932-.216c-.527-.114-.821-.351-.821-.712 0-.466.39-.804 1.046-.804.637 0 1.028.33 1.103.76h1.125c-.058-.923-.849-1.692-2.22-1.692-1.322 0-2.24.717-2.24 1.815 0 .91.588 1.446 1.52 1.657l.927.215c.624.145.923.36.923.778 0 .492-.391.83-1.13.83-.707 0-1.155-.342-1.234-.808H2.762c.052.95.79 1.75 2.315 1.75ZM8.307 11h2.19c1.81 0 2.684-1.107 2.684-3.015 0-1.894-.861-2.984-2.685-2.984H8.308z"/>
        </svg>
    ),
    'application': (
        <svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" fill="currentColor" viewBox="0 0 16 16">
            <path d="M15.698 7.287 8.712.302a1.03 1.03 0 0 0-1.457 0l-1.45 1.45 1.84 1.84a1.223 1.223 0 0 1 1.55 1.56l1.773 1.774a1.224 1.224 0 0 1 1.267 2.025 1.226 1.226 0 0 1-2.002-1.334L8.58 5.963v4.353a1.226 1.226 0 1 1-1.008-.036V5.887a1.226 1.226 0 0 1-.666-1.608L5.093 2.465l-4.79 4.79a1.03 1.03 0 0 0 0 1.457l6.986 6.986a1.03 1.03 0 0 0 1.457 0l6.953-6.953a1.03 1.03 0 0 0 0-1.457"/>
        </svg>
    ),
    'setting': (
        <svg xmlns="http://www.w3.org/2000/svg" width="28" height="28" viewBox="0 0 24 24" fill="none"
             stroke="currentColor" strokeWidth="1" strokeLinecap="round" strokeLinejoin="round">
            <path stroke="none" d="M0 0h24v24H0z" fill="none"/>
            <path d="M10.325 4.317c.426 -1.756 2.924 -1.756 3.35 0a1.724 1.724 0 0 0 2.573 1.066c1.543 -.94 3.31 .826 2.37 2.37a1.724 1.724 0 0 0 1.065 2.572c1.756 .426 1.756 2.924 0 3.35a1.724 1.724 0 0 0 -1.066 2.573c.94 1.543 -.826 3.31 -2.37 2.37a1.724 1.724 0 0 0 -2.572 1.065c-.426 1.756 -2.924 1.756 -3.35 0a1.724 1.724 0 0 0 -2.573 -1.066c-1.543 .94 -3.31 -.826 -2.37 -2.37a1.724 1.724 0 0 0 -1.065 -2.572c-1.756 -.426 -1.756 -2.924 0 -3.35a1.724 1.724 0 0 0 1.066 -2.573c-.94 -1.543 .826 -3.31 2.37 -2.37c1 .608 2.296 .07 2.572 -1.065"/>
            <path d="M9 12a3 3 0 1 0 6 0a3 3 0 0 0 -6 0"/>
        </svg>
    ),
};

export function getTopMenuIcon(key) {
    if (!key) return null;
    return topMenuIcons[key] ?? null;
}
